"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const zod_1 = require("zod");
const react_hook_form_1 = require("react-hook-form");
const zod_2 = require("@hookform/resolvers/zod");
const reactstrap_1 = require("reactstrap");
const classnames_1 = __importDefault(require("classnames"));
const react_bootstrap_1 = require("react-bootstrap");
const react_i18next_1 = require("react-i18next");
const Button_1 = __importDefault(require("../../../../consulta-acessibilidade/Button"));
const AccessibilityContext_1 = require("../../../../consulta-acessibilidade/contexts/AccessibilityContext");
const pesquisa_1 = require("../../../../../store/ducks/pesquisa");
const react_redux_1 = require("react-redux");
const AppContextProvider_1 = require("../../../../../shared/contexts/AppContextProvider");
const SearchContextProvider_1 = require("../../../../../shared/contexts/SearchContextProvider");
const schema = zod_1.z.object({
    searchTerm: zod_1.z.string().min(1, 'CampoBuscaObrigatorio'),
    searchOption: zod_1.z.string().min(1, 'CampoBuscaObrigatorio')
});
const MultimeiosSearch = ({ loading, error, guiasPesquisaRx }) => {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)();
    const { searchInputRef } = (0, AccessibilityContext_1.useAccessibilityContext)();
    const { selectedTab } = (0, AppContextProvider_1.useAppContext)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { search, lastSearchForm } = (0, SearchContextProvider_1.useSearchContext)();
    const { handleSubmit, reset, register, formState: { errors } } = (0, react_hook_form_1.useForm)({
        resolver: (0, zod_2.zodResolver)(schema),
        defaultValues: {
            searchOption: '74',
            searchTerm: ''
        }
    });
    const terms = (0, react_1.useMemo)(() => ([
        { label: t('LIVRE'), value: '74' },
        { label: t('TITULO'), value: '59' },
        { label: t('AUTOR'), value: '65' },
        { label: t('ASSUNTO'), value: '66' },
    ]), [t]);
    (0, react_1.useEffect)(() => {
        if (lastSearchForm) {
            reset({
                searchTerm: lastSearchForm.termo_pesquisa,
                searchOption: lastSearchForm.coluna_um,
            });
        }
        else {
            reset({
                searchTerm: '',
                searchOption: '74',
            });
        }
    }, [lastSearchForm, reset]);
    const handleSearch = (0, react_1.useCallback)((data) => __awaiter(void 0, void 0, void 0, function* () {
        let form = {
            termo_pesquisa: data.searchTerm,
            coluna_um: data.searchOption,
        };
        let params = {
            q: data.searchTerm,
            for: data.searchOption,
        };
        if (guiasPesquisaRx.length) {
            const isPesquisaPaginada = !!guiasPesquisaRx.find((guia) => guia.codigo === selectedTab &&
                guia.usa_consulta_paginada);
            if (isPesquisaPaginada) {
                const newParams = {
                    page: 1,
                    perPage: 20,
                    orderBy: process.env.REACT_APP_CONSULTA_PAGINADA_ORDENACAO,
                    direction: 'C',
                };
                dispatch((0, pesquisa_1.changeSearch)(false));
                params = Object.assign(Object.assign({}, params), newParams);
                form = Object.assign(Object.assign({}, form), newParams);
            }
        }
        yield search(form, params);
    }), [selectedTab]);
    return (react_1.default.createElement(react_bootstrap_1.Form, { onSubmit: handleSubmit(handleSearch), className: "content__left__input p-3" },
        react_1.default.createElement(reactstrap_1.Col, { lg: "8", md: "7", sm: "12", className: "input-holder mt-3" },
            react_1.default.createElement("div", { className: 'rotulo' }, t('CampoBusca')),
            react_1.default.createElement(react_bootstrap_1.FormControl, Object.assign({}, register('searchTerm'), { ref: (e) => {
                    register('searchTerm').ref(e);
                    searchInputRef.current = e;
                }, type: "search", className: "rad10 b-tema20 cortxt foco", placeholder: t('DigiteSuaBuscaAqui'), isInvalid: errors.searchTerm !== undefined })),
            errors.searchTerm ? (react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, { type: "invalid" }, t((_a = errors.searchTerm) === null || _a === void 0 ? void 0 : _a.message))) : ('')),
        react_1.default.createElement(reactstrap_1.Col, { lg: "2", md: "3", sm: "12", className: "input-holder mt-3" },
            react_1.default.createElement("div", { className: 'rotulo' }, t('TipoPesquisas')),
            react_1.default.createElement(react_bootstrap_1.FormControl, Object.assign({ as: "select", className: "b-tema20 cortxt rad10 s14" }, register('searchOption')), terms.map(term => (react_1.default.createElement("option", { key: `termo-${term.value}`, value: term.value }, term.label))))),
        react_1.default.createElement(reactstrap_1.Col, { md: "2", lg: "2", sm: "12", className: (0, classnames_1.default)(' mt-3 align-self-end pb-0', { 'mb-4': error }) },
            react_1.default.createElement(Button_1.default, { title: "Pesquisar", icon: "search", variant: 'primeiro ml-0 btn-responsivo', type: "submit", disabled: loading }))));
};
const mapStateToProps = (state) => ({
    guiasPesquisaRx: state.pageConfig.guiasPesquisa,
});
exports.default = (0, react_redux_1.connect)(mapStateToProps)(MultimeiosSearch);
